import { useState } from "react";
import { createLead } from "../../services/publicApi";

const initialForm = {
  fullName: "",
  phone: "",
  email: "",
  jobType: "",
  message: "",
};

function LeadForm() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState({ type: "idle", message: "" });

  const updateField = (event) => {
    setForm((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  };

  const submitLead = async (event) => {
    event.preventDefault();
    setStatus({ type: "loading", message: "Odesilam poptavku..." });

    try {
      await createLead(form);
      setForm(initialForm);
      setStatus({ type: "success", message: "Poptavka byla odeslana." });
    } catch (error) {
      setStatus({ type: "error", message: error.message });
    }
  };

  return (
    <form className="card p-5 sm:p-6" onSubmit={submitLead}>
      <div className="grid gap-4">
        <div className="grid gap-4 sm:grid-cols-2">
          <label className="grid gap-1.5 text-sm font-medium text-slate-200">
            Jmeno
            <input className="input" name="fullName" value={form.fullName} onChange={updateField} required placeholder="Jan Novak" />
          </label>
          <label className="grid gap-1.5 text-sm font-medium text-slate-200">
            Telefon
            <input className="input" name="phone" value={form.phone} onChange={updateField} required placeholder="+420 123 456 789" />
          </label>
        </div>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          E-mail
          <input className="input" name="email" type="email" value={form.email} onChange={updateField} required placeholder="jan@email.cz" />
        </label>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          Typ prace
          <select className="input" name="jobType" value={form.jobType} onChange={updateField} required>
            <option value="">Vyberte typ zakazky</option>
            <option value="installation">Elektroinstalace</option>
            <option value="reconstruction">Rekonstrukce</option>
            <option value="revision">Revize</option>
            <option value="data">Datove rozvody</option>
          </select>
        </label>
        <label className="grid gap-1.5 text-sm font-medium text-slate-200">
          Popis
          <textarea
            className="textarea"
            name="message"
            value={form.message}
            onChange={updateField}
            required
            placeholder="Strucne popiste, co potrebujete vyresit."
          />
        </label>
        {status.message && (
          <p className={`text-sm ${status.type === "error" ? "text-red-300" : "text-cyan-200"}`}>
            {status.message}
          </p>
        )}
        <button type="submit" className="btn-primary w-full sm:w-auto" disabled={status.type === "loading"}>
          Odeslat poptavku
        </button>
      </div>
    </form>
  );
}

export default LeadForm;
